import { Injectable } from '@angular/core';

/**
 * App settings service
 */
@Injectable({
  providedIn: 'root'
})
export class AppSettingsService {
  /**
   * The available RD locales
   */
  public availableReportDesignerLocales: any[];

  /**
   * All RD locales
   */
  public allReportDesignerLocales: any;
}
